import React from 'react';

const Spinners = props => (
    <div className="pt-1 text-center">
        <div className="spinner-border text-danger" />
    </div>
)

export default Spinners;